module fdm.rawFiles {

    angular.module('fdm.rawFiles')
        .config(($stateProvider: ng.ui.IStateProvider, $locationProvider: ng.ILocationProvider) => {

            dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
                    .listState('rawFiles', 'raw-files',
                    '{parentId}/raw-file/list', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions()
                            ]
                        }
                    })
                    .detailsState('rawFileDetails', 'raw-files',
                    '{parentId}/raw-file/{aggregateId}/details', {
                        templateUrl: () => '/app/src/raw-files/raw-file-details.html',
                        //options: (): dg.actions.IQueryResultDisplayerOptions => {
                        //    return {
                        //        exportOptions: {
                        //            title: "Summary"
                        //        },
                        //        childListOptions: {
                        //            listOptions: dg.lists.ListOptionsService.getGridOptions({
                        //                type: 'grid',
                        //                actionColumnEnabled: false,
                        //                useExternalSorting: true,
                        //                uiGrid: {
                        //                    columnDefs: [
                        //                        //{ field: 'aggregate', width: '30%' },
                        //                        //{ field: 'aircraft', width: 100 },
                        //                        //{ field: 'departure', width: 100 },
                        //                        //{ field: 'arival', width: 100 },
                        //                        //{ field: 'level', cellTemplate: '/src/flight-legs/flight-leg-level-grid-template-cell.html' }
                        //                    ]
                        //                },
                        //                useGridScroll: false
                        //            })
                        //        }
                        //    };
                        //}

                        //options: () => <dg.actions.IQueryResultDisplayerOptions>{
                        //    compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                        //        <dg.lists.IGridListOptions>_.merge(dg.lists.ListOptionsService.getGridOptions({
                        //            actionColumnEnabled: false,
                        //            useExternalSorting: true,
                        //            useGridScroll: false
                        //        }), {
                        //            exportOptions: {
                        //                title: "Summary"
                        //            }
                        //        })
                        //    ]
                        //}

                        options: () => <dg.actions.IQueryResultDisplayerOptions>{
                            exportOptions: {
                                title: "Summary"
                            },
                            childDisplayers: {
                                extractedLegs: dg.lists.ListOptionsService.getGridOptions({
                                    actionColumnEnabled: false,
                                    useExternalSorting: true,
                                    useGridScroll: false
                                })
                            }
                        }
                    })
                    .commandState('matchPerformedLegCommand', {
                        apiUrl: '{parentId}/raw-file/{aggregateId}/match-performed-leg-bulk',
                        propTemplateUrl: '/app/src/raw-files/match-performed-leg-bulk-prop-template.html',
                        modalOptions: {
                            windowClass: 'modal-xl'
                        }
                    })
                    ;

                //$stateProvider
                //    .state<dg.actions.IListQueryStateResolve>('app.flightLegs', {
                //        url: 'flight-legs?aircraft.id&readoutStatus.id',
                //        templateUrl: '/digmo/src/actions/list-query/default-list-query-view.html',
                //        apiUrl: "/{ownerId}/flight-leg/flight-legs",
                //        params: {
                //            'aircraft.id': null
                //        },
                //        resolve: {
                //            query: (actionService: dg.actions.ActionService, $transition$: any) => {
                //                //return actionService.getAction(`/flight-leg/flight-legs?aircraft.id=${$transition$.params()['aircraft.id']}`);
                //                //return actionService.getAction(`/flight-leg/flight-legs`, $transition$.params());
                //                //console.log(actionService.getAction('/flight-leg/flight-legs'));
                //                let params = $transition$.params();
                //                return actionService.getAction('/flight-leg/flight-legs', params);
                //            },
                //            options: ($transition$: any) => {
                //                var options: dg.lists.IGridListOptions = {
                //                    type: 'grid',
                //                    uiGrid: {
                //                        columnDefs: [
                //                            { field: 'aggregate', width: 125 },
                //                            { field: 'aircraft', width: 80 },
                //                            //{ field: 'departure', width: 100 },
                //                            //{ field: 'arrival', width: 100 },
                //                            //{ field: 'legDate', width: 100 },
                //                            { field: 'readoutStatus', width: 125 }
                //                        ]
                //                    }
                //                };
                //                return {
                //                    listOptions: dg.lists.ListOptionsService.getGridOptions(options),
                //                    queryParameters: $transition$.params()
                //                };
                //            }
                //        }
                //    })
                //    //.state('app.leg', {
                //    //    abstract: true,
                //    //    url: 'legs/:aggregateId',
                //    //    template: '<div ui-view></div>'
                //    //})
                //    //.state('app.leg.overview', {
                //    //    url: '/overview',
                //    //    templateUrl: '/src/legs/project-overview.html',
                //    //    controller: 'ProjectOverviewController',
                //    //    data: {
                //    //        apiUrl: null
                //    //    }
                //    //})
                //    .state<dg.actions.IQueryResultDisplayerStateResolve>('app.flightLeg', {
                //        url: 'flight-legs/:aggregateId/details',
                //        templateUrl: '/digmo/src/actions/query-result/default-query-result-view.html',
                //        apiUrl: '/{ownerId}/flight-leg/{aggregateId}/readout-report',
                //        //controller: 'ProjectDetailsController',
                //        //data: {
                //        //    apiUrl: '/{ownerId}/project/{aggregateId}/update-project'
                //        //},

                //        resolve: {
                //            templateUrl: () => '/src/flight-legs/flight-leg-details.html',
                //            queryResult: (actionService: dg.actions.ActionService, $transition$: any) => {
                //                return actionService.getModelQueryResult('/flight-leg/' + $transition$.params().aggregateId + '/readout-report/result');
                //            },

                //            options: (): dg.actions.IQueryResultDisplayerOptions => {
                //                return {
                //                    exportOptions: {
                //                        title: "Reports"
                //                    },
                //                    childListOptions: {
                //                        listOptions: dg.lists.ListOptionsService.getGridOptions({
                //                            type: 'grid',
                //                            actionColumnEnabled: false,
                //                            useExternalSorting: false,
                //                            uiGrid: {
                //                                columnDefs: [
                //                                    //{ field: 'aggregate', width: 100 },
                //                                    //{ field: 'aircraft', width: 100 },
                //                                    //{ field: 'departure', width: 100 },
                //                                    //{ field: 'arival', width: 100 },
                //                                    {
                //                                        field: 'level',
                //                                        cellTemplate: '/src/flight-legs/flight-leg-level-grid-template-cell.html'
                //                                    }]
                //                            }
                //                        })
                //                    }
                //                };
                //            }

                //        }
                //    })


                //.state('app.projectDefinition', {
                //    url: 'projects/definition',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-model.html',
                //    controller: 'DynamicActionController',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/project/define-project'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.project', {
                //    abstract: true,
                //    url: 'projects/:aggregateId',
                //    templateUrl: '/src/projects/project.html',
                //    controller: 'ProjectGeneralController'
                //})
                //.state('app.project.overview', {
                //    url: '/overview',
                //    templateUrl: '/src/projects/project-overview.html',
                //    controller: 'ProjectOverviewController',
                //    data: {
                //        apiUrl: null
                //    }
                //})
                //.state('app.project.details', {
                //    url: '/details',
                //    templateUrl: '/src/projects/project-details.html',
                //    controller: 'ProjectDetailsController',
                //    data: {
                //        apiUrl: '/{ownerId}/project/{aggregateId}/update-project'
                //    }
                //})
                //.state('app.project.operation', {
                //    url: '/operation',
                //    templateUrl: '/src/projects/project-operation.html',
                //    controller: 'ProjectOperationController',
                //    data: {
                //        apiUrl: null
                //    }
                //})
                //.state('app.project.operation.operationalFiles', {
                //    url: '/files/:parentId',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list-sm.html',
                //    controller: 'DynamicActionController',
                //    data: {
                //        apiUrl: '/{ownerId}/{parentId}/file-descriptor/operational-files',
                //    },
                //    resolve: {
                //        data: ['$stateParams', ($stateParams: dgUtils.IDgStateParamsService): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/' + $stateParams.parentId + '/file-descriptor/operational-files'
                //                },
                //                listInit: {
                //                    type: "grid",
                //                    gridOptions: {
                //                        type: "grid",
                //                        columnDefs: [
                //                            { field: 'aggregateId', width: 400 },
                //                            { field: 'note', width: '*' },
                //                            { field: 'createdBy', width: 240 },
                //                            { field: 'createdOn', width: 100 }
                //                        ]
                //                    }
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.project.operation.scheduledFiles', {
                //    url: '/scheduled/:parentId',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list-sm.html',
                //    controller: 'DynamicActionController',
                //    data: {
                //        apiUrl: '/{ownerId}/{parentId}/file-descriptor/scheduled-files',
                //    },
                //    resolve: {
                //        data: ['$stateParams', ($stateParams: dgUtils.IDgStateParamsService): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/' + $stateParams.parentId + '/file-descriptor/scheduled-files'
                //                },
                //                listInit: {
                //                    type: "grid",
                //                    gridOptions: {
                //                        type: "grid",
                //                        columnDefs: [
                //                            { field: 'aggregateId', width: 400 },
                //                            { field: 'note', width: '*' },
                //                            { field: 'periodStartDate', width: 140 },
                //                            { field: 'createdOn', width: 100 }
                //                        ]
                //                    }
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.project.products', {
                //    url: '/products',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list-sm.html',
                //    controller: 'ProjectProductsController',
                //    data: {
                //        apiUrl: '/{ownerId}/file-descriptor/product-files',
                //    },
                //    resolve: {
                //        data: ['$transition$', ($transition$: any): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/file-descriptor/product-files?fileOwnerId=' + $transition$.params().aggregateId
                //                },
                //                listInit: {
                //                    type: 'badge'
                //                }
                //            };
                //        }]
                //    }
                //})
                //.state('app.project.tasks', {
                //    url: '/tasks',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list-sm.html',
                //    controller: 'DynamicActionController',
                //    resolve: {
                //        data: ['$transition$', ($transition$: any): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/user-task/project-task-list?project=' + $transition$.params().aggregateId
                //                },
                //                listInit: {
                //                    type: "grid",
                //                    excelDownloadEnabled: true,
                //                    gridOptions: {
                //                        type: "grid",
                //                        columnDefs: [
                //                            { field: 'aggregateId', width: '*' },
                //                            { field: 'assignedTo', width: 340 },
                //                            { field: 'dueDate', width: 100 },
                //                            { field: 'taskStatus', width: 100 },
                //                            { field: 'dueStatus', width: 140 }  
                //                        ]
                //                    }
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.myProjects', {
                //    url: 'my-projects',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/project/my-project-list'
                //                },
                //                listInit: {
                //                    type: "grid",
                //                    excelDownloadEnabled: true,
                //                    gridOptions: {
                //                        type: "grid",
                //                        columnDefs: [
                //                            { field: 'aggregateId', width: 240 },
                //                            { field: 'roles', width: 340 },
                //                            { field: 'projectName', width: '*', minWidth: 200 },
                //                            { field: 'startDate', width: 100 },
                //                            { field: 'endDate', width: 140 }
                //                        ]
                //                    }
                //                }
                //            }
                //        }]
                //    }
                //});
            });

}
